export function getCsrfToken(): string {
  const token = document.querySelector('meta[name="csrf-token"]');
  return token?.getAttribute("content") ?? "";
}

export async function postRodauth(
  path: string,
  params: Record<string, string>
): Promise<Response> {
  const body = new URLSearchParams(params);

  return fetch(path, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRF-Token": getCsrfToken(),
    },
    body,
  });
}

export function rodauthSuccess(response: Response): boolean {
  return response.ok || response.redirected || response.status === 302;
}
